module.exports = __webpack_public_path__ + "img/unathorize.415655ef.svg";